import { QueryObserverOptions } from '@tanstack/react-query'

import { buildGetQuery } from '../../util'
import config from '../../config'

import { IPostRequestObject, IPagedResults, ISafetyCase, ISafetyCaseSearchFilter } from '../../interfaces'

const getFilteredSafetyCasesRequest = (
  params: undefined,
  queryObject: ISafetyCaseSearchFilter | undefined,
): IPostRequestObject => ({
  method: 'post',
  url: `${config.baseUrl}/sms/SafetyCases/Search`,
  data: queryObject,
})

const useSafetyCasesSearchQueryBase = buildGetQuery<
  undefined,
  ISafetyCaseSearchFilter | undefined,
  IPagedResults<ISafetyCase | undefined>
>({
  getRequest: getFilteredSafetyCasesRequest,
  getQueryKey: (params, queryObject) => [
    'safety-case-search',
    queryObject?.startedAtBegin,
    queryObject?.startedAtEnd,
    queryObject?.originatedFromSafetyReport,
    queryObject?.statusIds,
    queryObject?.searchTagIds,
    queryObject?.limit,
    queryObject?.page,
    queryObject?.sortBy,
    queryObject?.sortOrder,
  ],
  defaultOptions: { initialData: undefined, refetchOnWindowFocus: false },
})

const useSafetyCasesSearchQuery = (
  queryObject: ISafetyCaseSearchFilter | undefined,
  options?: QueryObserverOptions<IPagedResults<ISafetyCase | undefined>, Error>,
) => useSafetyCasesSearchQueryBase(undefined, queryObject, options)

export default useSafetyCasesSearchQuery
